import { rest } from 'msw'
import moment from 'moment'
moment.locale('ja')
export default [
  /**
   * ダイナミックプライシング一覧情報
   */
  rest.post('/api/v2/get_pricing_list', (req, res, ctx) => {
    // Persist user's authentication in the session
    const count = 4
    const page = req.body.page
    const data = [
      {
        id: 1,
        title: '登録内容確認（利用回数）１回のみ',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: 'https://content.retailstudio.jp/images/0001/dp/0001_01.jpg',
        point: 1000,
        openDate: moment().add(-4, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(-4, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        logic: 2,
        bonusType: 1,
        bonus: [
          { startTime: '10:00', endTime: '12:00', point: 10 },
          { startTime: '18:00', endTime: '19:00', point: 100 },
        ],
      },
      {
        id: 2,
        title: '（対象カテゴリー）購入金額（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        point: 120,
        openDate: moment().add(-4, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 1,
        periodStart: moment().add(-4, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 0,
        logic: 2,
        countLimit: 1,
      },
      {
        id: 3,
        title: '（対象カテゴリー）購入金額（毎）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        point: 120,
        openDate: moment().add(-4, 'days').unix(),
        closeDate: moment().add(-2, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(-4, 'days').unix(),
        periodEnd: moment().add(-2, 'days').unix(),
        countLimit: 0,
      },
      {
        id: 4,
        title: '（対象カテゴリー）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        point: 120,
        openDate: moment().add(5, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
      },
      {
        id: 5,
        title: '（対象カテゴリー）購入個数（毎）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        point: 120,
        openDate: '1646072130',
        closeDate: '1648664130',
        isPurchaseOnly: 0,
        periodStart: '1648664130',
        periodEnd: '1648664130',
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
      },
      {
        id: 6,
        title: '（対象商品）購入金額（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        point: 119,
        openDate: '1646072130',
        closeDate: '1648664130',
        isPurchaseOnly: 0,
        periodStart: '1646072130',
        periodEnd: '1648664130',
      },
      {
        id: 7,
        title: '（対象商品）購入金額（毎）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        point: 118,
        openDate: '1582815600',
        closeDate: '1585580400',
        isPurchaseOnly: 0,
        periodStart: '1582815600',
        periodEnd: '1585062000',
      },
      {
        id: 8,
        title: '（対象商品）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        point: 100,
        openDate: '1582815600',
        closeDate: '1585580400',
        isPurchaseOnly: 0,
        periodStart: '1582815600',
        periodEnd: '1585062000',
      },
      {
        id: 9,
        title: '（対象商品）購入個数（毎）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        point: 100,
        openDate: '1582815600',
        closeDate: '1585580400',
        isPurchaseOnly: 0,
        periodStart: '1582815600',
        periodEnd: '1585062000',
      },
      {
        id: 10,
        title: '（指定なし）表示名称',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        point: 100,
        openDate: '1582815600',
        closeDate: '1585580400',
        isPurchaseOnly: 0,
        periodStart: '1582815600',
        periodEnd: '1585062000',
      },
      {
        id: 11,
        title: '（指定なし）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        point: 100,
        openDate: '1582815600',
        closeDate: '1585580400',
        isPurchaseOnly: 0,
        periodStart: '1582815600',
        periodEnd: '1585062000',
      },
      {
        id: 12,
        title: '（指定なし）購入個数（毎）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        point: 100,
        openDate: '1582815600',
        closeDate: '1585580400',
        isPurchaseOnly: 0,
        periodStart: '1582815600',
        periodEnd: '1585062000',
      },
      {
        id: 13,
        title: '（指定なし）購入金額（毎）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        point: 100,
        openDate: '1582815600',
        closeDate: '1585580400',
        isPurchaseOnly: 0,
        periodStart: '1582815600',
        periodEnd: '1585062000',
      },
      {
        id: 14,
        title: '（指定なし）購入金額（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        point: 100,
        openDate: '1582815600',
        closeDate: '1585580400',
        isPurchaseOnly: 0,
        periodStart: '1582815600',
        periodEnd: '1585062000',
      },
      {
        id: 15,
        title: '登録内容確認（最低金額）テストケース2',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        point: 100,
        openDate: '1582815600',
        closeDate: '1585580400',
        isPurchaseOnly: 0,
        periodStart: '1582815600',
        periodEnd: '1585062000',
      },
      {
        id: 16,
        title: '登録内容確認（最低金額）テストケース1',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        point: 100,
        openDate: '1582815600',
        closeDate: '1585580400',
        isPurchaseOnly: 0,
        periodStart: '1582815600',
        periodEnd: '1585062000',
      },
      {
        id: 17,
        title: '登録内容確認（対象商品）テストケース５',
        thumbnail:
          'https://static-stg.tableva.jp/assets/pricings/79/thumb_04fc2896573a87b856e22a080252a38e.jpg',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        point: 1,
        openDate: '1582729200',
        closeDate: '1585321200',
        isPurchaseOnly: 0,
        periodStart: '1582729200',
        periodEnd: '1585321200',
      },
      {
        id: 18,
        title: '登録内容確認（対象商品）テストケース４',
        thumbnail:
          'https://static-stg.tableva.jp/assets/pricings/79/thumb_04fc2896573a87b856e22a080252a38e.jpg',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        point: 100,
        openDate: '1582729200',
        closeDate: '1585321200',
        isPurchaseOnly: 0,
        periodStart: '1582729200',
        periodEnd: '1585321200',
      },
      {
        id: 19,
        title: '登録内容確認（対象商品）テストケース3',
        thumbnail:
          'https://static-stg.tableva.jp/assets/pricings/79/thumb_04fc2896573a87b856e22a080252a38e.jpg',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        point: 1,
        openDate: '1582729200',
        closeDate: '1585321200',
        isPurchaseOnly: 0,
        periodStart: '1582729200',
        periodEnd: '1585321200',
      },
      {
        id: 20,
        title: '登録内容確認（対象商品）テストケース2',
        thumbnail:
          'https://static-stg.tableva.jp/assets/pricings/79/thumb_04fc2896573a87b856e22a080252a38e.jpg',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        point: 100,
        openDate: '1582729200',
        closeDate: '1585321200',
        isPurchaseOnly: 0,
        periodStart: '1582729200',
        periodEnd: '1585321200',
      },
      {
        id: 21,
        title: '登録内容確認（対象商品）テストケース１',
        thumbnail:
          'https://static-stg.tableva.jp/assets/pricings/79/thumb_04fc2896573a87b856e22a080252a38e.jpg',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        point: 100,
        openDate: '1582729200',
        closeDate: '1585321200',
        isPurchaseOnly: 0,
        periodStart: '1582729200',
        periodEnd: '1585321200',
      },
      {
        id: 22,
        title: '登録内容確認（注意事項）',
        thumbnail:
          'https://static-stg.tableva.jp/assets/pricings/79/thumb_04fc2896573a87b856e22a080252a38e.jpg',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        point: 1,
        openDate: '1582729200',
        closeDate: '1585321200',
        isPurchaseOnly: 0,
        periodStart: '1582729200',
        periodEnd: '1585321200',
      },
      {
        id: 23,
        title: '登録内容確認（画像）',
        thumbnail:
          'https://static-stg.tableva.jp/assets/pricings/79/thumb_04fc2896573a87b856e22a080252a38e.jpg',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        point: 1,
        openDate: '1582729200',
        closeDate: '1585321200',
        isPurchaseOnly: 0,
        periodStart: '1582729200',
        periodEnd: '1585321200',
      },
      {
        id: 24,
        title: '登録内容確認（本文テキスト）',
        thumbnail:
          'https://static-stg.tableva.jp/assets/pricings/83/thumb_794334320a248b21b768130fa00086aa.jpg',
        thumbnailAttribute: {
          height: 3840,
          width: 2160,
        },
        mainImage: '',
        point: 1,
        openDate: '1582729200',
        closeDate: '1585321200',
        isPurchaseOnly: 0,
        periodStart: '1582729200',
        periodEnd: '1585321200',
      },
      {
        id: 25,
        title: '登録内容確認（サブタイトル）',
        thumbnail:
          'https://static-stg.tableva.jp/assets/pricings/81/thumb_71ff68d50206c47e0e1ae967166d07b7.jpg',
        thumbnailAttribute: {
          height: 3840,
          width: 2160,
        },
        mainImage: '',
        point: 1,
        openDate: '1582729200',
        closeDate: '1585321200',
        isPurchaseOnly: 0,
        periodStart: '1582729200',
        periodEnd: '1585321200',
      },
    ]
    const totalPage = Math.ceil(data.length / count)
    const items = data.splice((page - 1) * count, count)
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          items,
          count,
          totalCount: data.length,
          totalPage,
          responseTime: 1580095261,
        },
      })
    )
  }),
  /**
   * ダイナミックプライシングカテゴリ一覧情報
   */
  rest.post('/api/v2/get_pricing_category', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          categories: [
            {
              id: 2,
              name: '特集',
              key: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
            },
            {
              id: 3,
              name: '魚介類',
              key: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
            },
            {
              id: 4,
              name: '野菜類',
              key: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
            },
            {
              id: 5,
              name: '肉類',
              key: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
            },
            {
              id: 6,
              name: 'お惣菜',
              key: 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxx',
            },
          ],
        },
      })
    )
  }),
  /**
   * ダイナミックプライシング詳細情報
   */
  rest.post('/api/v2/get_pricing_detail', (req, res, ctx) => {
    // Persist user's authentication in the session
    const id = req.body.id
    const data = [
      {
        id: 1,
        title: '登録内容確認（利用回数）１回のみ',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: 'https://content.retailstudio.jp/images/0001/dp/0001_01.jpg',
        pointName: 'Sポイント',
        point: 1000,
        openDate: moment().add(-4, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(-4, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [
          { startTime: '10:00', endTime: '12:00', point: 10 },
          { startTime: '18:00', endTime: '19:00', point: 100 },
        ],
        distributionTargetType: 0,
        details: [],
        logic: 2,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 2,
            },
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 2,
            },
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 2,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 2,
          amount: null,
          dispName: '',
          jan_type: 1,
        },
        target2: {
          products: [
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 2,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 2,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 2,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 2,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 2,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 2,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 2,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 2,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 2,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 アップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 パインアップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 マンゴーブレンド',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 メロンテイスト',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'カゴメ 野菜生活１００ 濃厚果実 ラ・フランスミックス',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Smoothie オレンジざくろ&ヨーグルトMix',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
          ],
          quantity: null,
          amount: 300,
          dispName: '',
          jan_type: 1,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 2,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 2,
        title: '（対象カテゴリー）購入金額（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(-4, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 1,
        periodStart: moment().add(-4, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 0,
        bonusType: 0,
        bonus: [],
        distributionTargetType: 0,
        details: [],
        logic: 0,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 2,
          amount: null,
          dispName: '',
          jan_type: 1,
        },
        target2: {
          products: [],
          quantity: null,
          amount: 300,
          dispName: '',
          jan_type: 1,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 3,
        title: '（対象カテゴリー）購入金額（毎）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(-4, 'days').unix(),
        closeDate: moment().add(-2, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(-4, 'days').unix(),
        periodEnd: moment().add(-2, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
        distributionTargetType: 0,
        details: [],
        logic: 0,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 2,
          amount: null,
          dispName: 'TEST',
          jan_type: 1,
        },
        target2: {
          products: [],
          quantity: null,
          amount: 300,
          dispName: '',
          jan_type: 1,
        },
        shops: [],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 4,
        title: '（対象カテゴリー）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(5, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
        distributionTargetType: 0,
        details: [],
        logic: 2,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 アップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 パインアップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 マンゴーブレンド',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 メロンテイスト',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'カゴメ 野菜生活１００ 濃厚果実 ラ・フランスミックス',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Smoothie オレンジざくろ&ヨーグルトMix',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 5,
        title: '（対象カテゴリー）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(5, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
        distributionTargetType: 0,
        details: [],
        logic: 1,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 アップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 パインアップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 マンゴーブレンド',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 メロンテイスト',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'カゴメ 野菜生活１００ 濃厚果実 ラ・フランスミックス',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Smoothie オレンジざくろ&ヨーグルトMix',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 6,
        title: '（対象カテゴリー）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(5, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
        distributionTargetType: 0,
        details: [],
        logic: 2,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 アップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 パインアップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 マンゴーブレンド',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 メロンテイスト',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'カゴメ 野菜生活１００ 濃厚果実 ラ・フランスミックス',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Smoothie オレンジざくろ&ヨーグルトMix',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 7,
        title: '（対象カテゴリー）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(5, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
        distributionTargetType: 0,
        details: [],
        logic: 2,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 アップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 パインアップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 マンゴーブレンド',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 メロンテイスト',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'カゴメ 野菜生活１００ 濃厚果実 ラ・フランスミックス',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Smoothie オレンジざくろ&ヨーグルトMix',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 8,
        title: '（対象カテゴリー）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(5, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
        distributionTargetType: 0,
        details: [],
        logic: 2,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 アップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 パインアップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 マンゴーブレンド',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 メロンテイスト',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'カゴメ 野菜生活１００ 濃厚果実 ラ・フランスミックス',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Smoothie オレンジざくろ&ヨーグルトMix',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 9,
        title: '（対象カテゴリー）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(5, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
        distributionTargetType: 0,
        details: [],
        logic: 2,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 アップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 パインアップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 マンゴーブレンド',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 メロンテイスト',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'カゴメ 野菜生活１００ 濃厚果実 ラ・フランスミックス',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Smoothie オレンジざくろ&ヨーグルトMix',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 10,
        title: '（対象カテゴリー）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(5, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
        distributionTargetType: 0,
        details: [],
        logic: 2,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 アップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 パインアップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 マンゴーブレンド',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 メロンテイスト',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'カゴメ 野菜生活１００ 濃厚果実 ラ・フランスミックス',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Smoothie オレンジざくろ&ヨーグルトMix',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 11,
        title: '（対象カテゴリー）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(5, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
        distributionTargetType: 0,
        details: [],
        logic: 2,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 アップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 パインアップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 マンゴーブレンド',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 メロンテイスト',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'カゴメ 野菜生活１００ 濃厚果実 ラ・フランスミックス',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Smoothie オレンジざくろ&ヨーグルトMix',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 12,
        title: '（対象カテゴリー）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(5, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
        distributionTargetType: 0,
        details: [],
        logic: 2,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 アップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 パインアップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 マンゴーブレンド',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 メロンテイスト',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'カゴメ 野菜生活１００ 濃厚果実 ラ・フランスミックス',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Smoothie オレンジざくろ&ヨーグルトMix',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 13,
        title: '（対象カテゴリー）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(5, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
        distributionTargetType: 0,
        details: [],
        logic: 2,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 アップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 パインアップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 マンゴーブレンド',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 メロンテイスト',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'カゴメ 野菜生活１００ 濃厚果実 ラ・フランスミックス',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Smoothie オレンジざくろ&ヨーグルトMix',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 14,
        title: '（対象カテゴリー）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(5, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
        distributionTargetType: 0,
        details: [],
        logic: 2,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 アップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 パインアップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 マンゴーブレンド',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 メロンテイスト',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'カゴメ 野菜生活１００ 濃厚果実 ラ・フランスミックス',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Smoothie オレンジざくろ&ヨーグルトMix',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 15,
        title: '（対象カテゴリー）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(5, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
        distributionTargetType: 0,
        details: [],
        logic: 2,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 アップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 パインアップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 マンゴーブレンド',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 メロンテイスト',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'カゴメ 野菜生活１００ 濃厚果実 ラ・フランスミックス',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Smoothie オレンジざくろ&ヨーグルトMix',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 16,
        title: '（対象カテゴリー）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(5, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
        distributionTargetType: 0,
        details: [],
        logic: 2,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 アップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 パインアップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 マンゴーブレンド',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 メロンテイスト',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'カゴメ 野菜生活１００ 濃厚果実 ラ・フランスミックス',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Smoothie オレンジざくろ&ヨーグルトMix',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 17,
        title: '（対象カテゴリー）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(5, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
        distributionTargetType: 0,
        details: [],
        logic: 2,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 アップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 パインアップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 マンゴーブレンド',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 メロンテイスト',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'カゴメ 野菜生活１００ 濃厚果実 ラ・フランスミックス',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Smoothie オレンジざくろ&ヨーグルトMix',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 18,
        title: '（対象カテゴリー）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(5, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
        distributionTargetType: 0,
        details: [],
        logic: 2,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 アップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 パインアップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 マンゴーブレンド',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 メロンテイスト',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'カゴメ 野菜生活１００ 濃厚果実 ラ・フランスミックス',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Smoothie オレンジざくろ&ヨーグルトMix',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 19,
        title: '（対象カテゴリー）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(5, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
        distributionTargetType: 0,
        details: [],
        logic: 2,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 アップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 パインアップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 マンゴーブレンド',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 メロンテイスト',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'カゴメ 野菜生活１００ 濃厚果実 ラ・フランスミックス',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Smoothie オレンジざくろ&ヨーグルトMix',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 20,
        title: '（対象カテゴリー）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(5, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
        distributionTargetType: 0,
        details: [],
        logic: 2,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 アップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 パインアップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 マンゴーブレンド',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 メロンテイスト',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'カゴメ 野菜生活１００ 濃厚果実 ラ・フランスミックス',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Smoothie オレンジざくろ&ヨーグルトMix',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 21,
        title: '（対象カテゴリー）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(5, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
        distributionTargetType: 0,
        details: [],
        logic: 2,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 アップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 パインアップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 マンゴーブレンド',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 メロンテイスト',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'カゴメ 野菜生活１００ 濃厚果実 ラ・フランスミックス',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Smoothie オレンジざくろ&ヨーグルトMix',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 22,
        title: '（対象カテゴリー）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(5, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
        distributionTargetType: 0,
        details: [],
        logic: 2,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 アップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 パインアップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 マンゴーブレンド',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 メロンテイスト',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'カゴメ 野菜生活１００ 濃厚果実 ラ・フランスミックス',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Smoothie オレンジざくろ&ヨーグルトMix',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 23,
        title: '（対象カテゴリー）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(5, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
        distributionTargetType: 0,
        details: [],
        logic: 2,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 アップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 パインアップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 マンゴーブレンド',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 メロンテイスト',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'カゴメ 野菜生活１００ 濃厚果実 ラ・フランスミックス',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Smoothie オレンジざくろ&ヨーグルトMix',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 24,
        title: '（対象カテゴリー）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(5, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
        distributionTargetType: 0,
        details: [],
        logic: 2,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 アップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 パインアップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 マンゴーブレンド',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 メロンテイスト',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'カゴメ 野菜生活１００ 濃厚果実 ラ・フランスミックス',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Smoothie オレンジざくろ&ヨーグルトMix',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
      {
        id: 25,
        title: '（対象カテゴリー）購入個数（以上）',
        thumbnail: 'https://placehold.jp/150x150.png',
        thumbnailAttribute: {
          height: 2160,
          width: 3840,
        },
        mainImage: '',
        pointName: 'Sポイント',
        point: 120,
        openDate: moment().add(5, 'days').unix(),
        closeDate: moment().add(5, 'days').unix(),
        isPurchaseOnly: 0,
        periodStart: moment().add(5, 'days').unix(),
        periodEnd: moment().add(5, 'days').unix(),
        purchaseTarget: 1,
        bonusType: 1,
        bonus: [{ startTime: '10:00', endTime: '12:00', point: 10 }],
        distributionTargetType: 0,
        details: [],
        logic: 2,
        target1: {
          products: [
            {
              jancode: '000101_000013_000133_013301',
              name: 'グロッサリー/ドライグッズ/乾麺/中華そば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013302',
              name: 'グロッサリー/ドライグッズ/乾麺/焼きそば',
              unit: 1,
            },
            {
              jancode: '000101_000013_000133_013303',
              name: 'グロッサリー/ドライグッズ/乾麺/濡れそば',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        target2: {
          products: [
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープフルーツ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 オレンジ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 アップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 パインアップル',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 マンゴーブレンド',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 グレープ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'トロピカーナ 100 まるごと果実感 メロンテイスト',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: 'カゴメ 野菜生活１００ 濃厚果実 ラ・フランスミックス',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Smoothie オレンジざくろ&ヨーグルトMix',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
            {
              name: '野菜生活１００ Ｃａｒｅ＋ ピーチ・アップルｍｉｘ',
              jancode: '0219901000000',
              unit: 1,
            },
          ],
          quantity: 55,
          amount: 1,
          dispName: '',
          jan_type: 2,
        },
        shops: [
          { name: '大崎店', code: '1' },
          { name: '品川店', code: '1' },
          { name: '新宿小滝橋店', code: '1' },
          { name: '飯田橋店', code: '1' },
          { name: '荒川西日暮里店', code: '1' },
          { name: '荒川東日暮里店', code: '1' },
          { name: '板橋小豆沢店', code: '1' },
          { name: '江戸川船堀店', code: '1' },
        ],
        countLimit: 0,
        quantityLimit: 0,
        mustAmount: null,
        taxType: 1,
        condition: '',
        caution: '購入してからポイントが付くまで1週間ほど時間がかかります。',
        appNo: '007-00498',
        responseTime: 1599615532,
      },
    ]
    const filter = data.filter(item => item.id === Number(id))
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: filter[0] || {},
      })
    )
  }),
  /**
   * ダイナミックプライシング詳細情報
   */
  rest.get('/api/v2/get_pricing_detail', (req, res, ctx) => {
    // Persist user's authentication in the session
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          id: 1,
          title: '北海道の新じゃがを使ったポテトサラダ',
          openDate: '915148799',
          closeDate: '1569829012',
          details: [
            {
              seq: 1,
              type: '1',
              background: 'gray',
              body: 'タイトル',
              attribute: {
                icon: '1',
              },
            },
            {
              seq: 2,
              type: '2',
              background: 'gray',
              body: "本文<br/>本文<br/><p class='comment_left'>本文</p>",
              attribute: {},
            },
            {
              seq: 3,
              type: '3',
              background: 'gray',
              body:
                'https://content.retailstudio.jp/images/0001/dp/0001_thumb.jpg',
              attribute: {
                height: '100',
                width: '100',
              },
            },
          ],
          pointType: 'ボーナスポイント',
          point: 50,
          isAnswered: 0,
          surveyCount: 5,
          surveys: [
            {
              id: 11,
              seq: 1,
              title: 'アンケート',
              question: 'この商品を購入したことがありますか',
              type: 'yesno',
              answers: [],
              hasFreeText: 0,
            },
            {
              id: 12,
              seq: 2,
              title: 'アンケート',
              question:
                'この商品はどういう時にお買い上げいただくことが多いですか？',
              type: 'checkbox',
              answers: [
                {
                  seq: 1,
                  label: '忙しい時にもう一品簡単に用意したい',
                },
                {
                  seq: 2,
                  label: '子供が大好きな・・・',
                },
                {},
              ],
              hasFreeText: 0,
            },
            {
              id: 13,
              seq: 3,
              title: 'アンケート',
              question:
                'この商品はどういう時にお買い上げいただくことが多いですか？',
              type: 'radio',
              answers: [
                {
                  seq: 1,
                  label: '忙しい時にもう一品簡単に用意したい',
                },
                {
                  seq: 2,
                  label: '子供が大好きな・・・',
                },
                {},
              ],
              hasFreeText: 0,
            },
            {
              id: 14,
              seq: 4,
              title: 'アンケート',
              question:
                'この商品はどういう時にお買い上げいただくことが多いですか？',
              type: 'radio',
              answers: [
                {
                  seq: 1,
                  label: '忙しい時にもう一品簡単に用意したい',
                },
                {
                  seq: 2,
                  label: '子供が大好きな・・・',
                },
                {},
                {
                  seq: 5,
                  label: 'その他',
                },
              ],
              hasFreeText: 1,
            },
            {
              id: 15,
              seq: 5,
              title: 'アンケート',
              question: 'この商品を評価してください',
              type: 'star',
              answers: [
                {
                  seq: 1,
                  label: '美味しさ',
                },
                {
                  seq: 2,
                  label: '価格',
                },
                {
                  seq: 3,
                  label: '鮮度',
                },
                {
                  seq: 4,
                  label: '便利さ',
                },
                {},
              ],
              hasFreeText: 0,
            },
            {
              id: 16,
              seq: 6,
              title: 'アンケート',
              question: 'この商品で何かご意見がありましたら、お書きください',
              type: 'freeText',
              answers: [],
              hasFreeText: 0,
            },
          ],
          responseTime: '915148799',
        },
      })
    )
  }),
]
